module.exports = __webpack_public_path__ + "img/mastersoft.8e2ab9d3.png";